import React, { useId, useState } from 'react';
import { splitQuotedHistory } from '../../lib/emailThreads';
export function EmailQuoteBody({ text }) {
    const [open, setOpen] = useState(false);
    const id = useId();
    const { content, quoted } = splitQuotedHistory(text);
    return <div className="whitespace-pre-wrap break-words">{content}{quoted && <>
        <button type="button" className="email-thread-toggle block rounded border px-3 py-1 mt-2" aria-label={open ? 'Hide quoted history' : 'Show quoted history'} aria-expanded={open} aria-controls={id} onClick={() => setOpen(!open)}>…</button>
        <div id={id} hidden={!open} className="mt-2 border-l-2 pl-3">{quoted}</div>
    </>}</div>;
}
export default function EmailThreadBlock({ messages, subject }) {
    const [expanded, setExpanded] = useState({});
    const prefix = useId();
    const allCollapsed = messages.every((message, index) => (expanded[message.id] ?? index === messages.length - 1) === false);
    const allExpanded = messages.every((message, index) => expanded[message.id] ?? index === messages.length - 1);
    const threadRegion = `${prefix}-thread`;

    return <section className="email-thread-block w-full min-w-0 rounded-xl border p-3" aria-label="Email thread">
        <h3 data-email-subject="true" className="mb-2 font-semibold break-words"><button type="button" className="email-thread-toggle flex items-center gap-2 text-left" aria-expanded={!allCollapsed} aria-controls={threadRegion} onClick={() => setExpanded(Object.fromEntries(messages.map(m => [m.id, allCollapsed])))}>
            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" style={{ transform: allCollapsed ? 'rotate(-90deg)' : undefined }}><path d="m3 5 5 5 5-5" fill="none" stroke="currentColor" strokeWidth="2" /></svg>
            {[...messages].reverse().find((m)=>m.emailSubject)?.emailSubject || subject || '(no subject)'} ({messages.length})</button></h3>
        <div className="flex gap-2 mb-2" aria-label="Thread expansion">
            <button type="button" className="email-thread-toggle rounded border px-2 py-1" aria-controls={threadRegion} onClick={() => setExpanded(Object.fromEntries(messages.map(m => [m.id, !allExpanded])))}>{allExpanded ? 'Collapse all' : 'Expand all'}</button>
        </div>
        <div id={threadRegion}>
        {messages.map((message, index) => {
            const open = expanded[message.id] ?? index === messages.length - 1;
            const region = `${prefix}-${index}`;
            const sender = message.emailFrom || message.staffName || (message.direction === 'outbound' ? 'Sent from mailbox' : 'Sender');
            const time = message.at ? new Date(message.at).toLocaleString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : '';
            return <article key={message.id} className="border-t py-2">
                <button type="button" className="email-thread-toggle w-full rounded p-2 text-left" aria-expanded={open} aria-controls={region} onClick={() => setExpanded((v) => ({ ...v, [message.id]: !open }))}>
                    <span aria-hidden="true">{open ? '▾' : '▸'} </span><span className="font-semibold">{sender}</span> <time>{time}</time>
                    {!open && <span className="block truncate">{String(message.text || '').split(/(?<=[.!?])\s|\n/)[0]}</span>}
                    <span className="sr-only">{open ? 'Collapse email' : 'Expand email'}</span>
                </button>
                <div id={region} hidden={!open} className="px-2 py-2">
                    {message.emailSyncError && <p role="status" className="mb-2">Message headers synced. Its body exceeds the size limit and was skipped.</p>}
                    <EmailQuoteBody text={message.emailFullText || message.text} />

                </div>
            </article>;
        })}
        </div>
    </section>;
}
